var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import * as ServiceDocument from '../../services/document';
import { EditionDocument } from './EditionDocument';
//import { DocumentViewer } from './DocumentViewer'
import { useState } from 'react';
import { CloseIcon, ExportIcon } from '../../utils/Icons';
import { Stack } from '@mui/material';
import { Table } from '../../utils/Table';
import { ConfirmDialog } from '../../utils/ConfirmDialog';
import { IconButton } from '../../utils/IconButton';
import { formatDate } from '../../services/utils/utils';
export var Document = function (props) {
    var Model = props.Model, ModelId = props.ModelId, Viewer = props.Viewer, CanEditDocument = props.CanEditDocument;
    var _a = useState([]), documents = _a[0], setDocuments = _a[1];
    //const [viewer, setViewer] = useState(null)
    var _b = useState(0), total = _b[0], setTotal = _b[1];
    var getData = function (_a) {
        var _b = _a.page, page = _b === void 0 ? 1 : _b, _c = _a.itemByPage, itemByPage = _c === void 0 ? 10 : _c;
        return __awaiter(void 0, void 0, void 0, function () {
            var _d, Documents, Total, error_1;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        _e.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, ServiceDocument.getDocumentListe(Model, ModelId, page, itemByPage)];
                    case 1:
                        _d = _e.sent(), Documents = _d.Documents, Total = _d.Total;
                        setDocuments(Documents);
                        //handleViewDocument(Documents[0].IdDocument)
                        setTotal(Total);
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _e.sent();
                        setDocuments([]);
                        setTotal(0);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /*const handleViewDocument = async (IdDocument) => {
      const { Type, Base64, Name } = await ServiceDocument.getDocument(
        IdDocument,
        Model,
        ModelId
      )
      setViewer({
        Type,
        Base64,
        Name,
        DocumentId: IdDocument,
      })
    }*/
    var handleClickDelete = function (documentId, refresh) { return __awaiter(void 0, void 0, void 0, function () {
        var confirmation;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, ConfirmDialog({
                        title: 'Suppression',
                        content: 'Êtes-vous sûr de vouloir supprimer ce document ?',
                        color: 'error',
                    })];
                case 1:
                    confirmation = _a.sent();
                    if (!confirmation.isOk) return [3 /*break*/, 3];
                    return [4 /*yield*/, ServiceDocument.deleteDocument(documentId)];
                case 2:
                    _a.sent();
                    refresh();
                    _a.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var handleExport = function (IdDocument) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, ServiceDocument.exportDocument(IdDocument, Model, ModelId)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    return (_jsx(Stack, __assign({ direction: "row" }, { children: _jsx(Table, { canEdit: CanEditDocument, renderModalEdition: function (handleClose, _a) {
                var DocumentId = _a.DocumentId;
                return (_jsx(EditionDocument, { DocumentId: DocumentId, Model: Model, ModelId: ModelId, onChange: function () { return handleClose(); } }));
            }, refresh: getData, total: total, headers: [
                {
                    label: 'Type',
                    component: function (value) {
                        return value.document_type ? value.document_type.Libelle : '-';
                    },
                },
                {
                    label: 'Libelle',
                    assessor: 'Libelle',
                },
                {
                    label: 'Date création',
                    component: function (value) {
                        return value.createdAt ? formatDate(value.createdAt, false) : '-';
                    },
                },
                {
                    align: 'right',
                    component: function (value, _a) {
                        var refresh = _a.refresh, handleUpdate = _a.handleUpdate;
                        return (_jsxs(_Fragment, { children: [value.Path && (_jsx(IconButton, __assign({ tooltip: "T\u00E9l\u00E9charger", onClick: function () { return handleExport(value.IdDocument); } }, { children: _jsx(ExportIcon, {}) }))), CanEditDocument && (_jsx(_Fragment, { children: _jsx(IconButton, __assign({ color: "error", tooltip: "Supprimer", onClick: function () {
                                            return handleClickDelete(value.IdDocument, refresh);
                                        } }, { children: _jsx(CloseIcon, {}) })) }))] }));
                    },
                },
            ], datas: documents ? documents : [] }) })));
};
//# sourceMappingURL=Document.js.map